import React, {Fragment} from 'react';
import {Row, Col, Input, Label, Button} from 'reactstrap';

import CKEditor from 'ckeditor4-react';
import customConst from "../../../global";

const editorConfig = customConst.editorConfig;

const InvoiceDetailEurForm = props => {
    return (
        <Fragment>
            <Row>
                <Col>
                    <Label for='eur_detail'>Detail *</Label>
                    <CKEditor
                        id='eur_detail'
                        type={editorConfig.type}
                        readOnly={props.disabled}
                        data={props.detail === null ? "" : props.detail}
                        config={editorConfig}
                        onChange={props.eurCkEditorDetail}
                        name='detail'
                    />
                </Col>
            </Row>

            <Row>
                <Col>
                    <Label>Deal</Label>
                    <Input
                        disabled={props.disabled}
                        value={props.deal}
                        type='text'
                        name='deal'
                        onChange={props.eurDetailChangeHandler}/>
                </Col>

                <Col>
                    <Label>Sum *</Label>
                    <Input
                        disabled={props.disabled}
                        value={props.sum}
                        required
                        type='number'
                        name='sum'
                        onChange={props.eurDetailChangeHandler}
                    />
                </Col>
            </Row>
            {!props.disabled ? <Row>
                <Col>
                    <Button color='danger' onClick={props.deleteEurDetail} className="mt30">Delete detail</Button>
                </Col>
            </Row> : null}
        </Fragment>
    );
};

export default InvoiceDetailEurForm;
